// Tiny DOM helpers for the /linux page (no framework; user data only ever goes through textContent).
export function h(tag, attrs, ...children) {
	const el = document.createElement(tag);
	if (attrs) {
		for (const [k, v] of Object.entries(attrs)) {
			if (v == null || v === false) continue;
			if (k === "class") el.className = v;
			else if (k === "text") el.textContent = v;
			else if (k === "html") el.innerHTML = v; // build-time constant SVG only
			else if (k.startsWith("on") && typeof v === "function") el.addEventListener(k.slice(2), v);
			else if (k === "dataset") Object.assign(el.dataset, v);
			else el.setAttribute(k, v === true ? "" : String(v));
		}
	}
	for (const c of children.flat()) if (c != null && c !== false) el.append(c instanceof Node ? c : String(c));
	return el;
}
export const btn = (label, onclick, cls = "", attrs = {}) => h("button", { type: "button", class: "rv-btn " + cls, onclick, ...attrs }, label);

// Triggers a browser download for a Blob (the iframe sandbox allows downloads).
export function saveBlob(blob, name) {
	const url = URL.createObjectURL(blob);
	const a = h("a", { href: url, download: name });
	document.body.append(a);
	a.click();
	a.remove();
	setTimeout(() => URL.revokeObjectURL(url), 30000);
}

// Promise-based modal. `build(close)` returns the dialog body; close(value) resolves the promise.
export function modal(build, { label = "Dialog" } = {}) {
	return new Promise((resolve) => {
		const prev = document.activeElement;
		const wrap = h("div", { class: "rv-lx-modal", role: "presentation" });
		const close = (v) => { wrap.remove(); document.removeEventListener("keydown", onKey, true); try { if (prev && prev.focus) prev.focus(); } catch (e) {} resolve(v); };
		// Escape closes; Tab and Shift+Tab stay inside the dialog while it is open.
		const onKey = (e) => {
			if (e.key === "Escape") { e.preventDefault(); close(undefined); return; }
			if (e.key !== "Tab") return;
			const items = [...dialog.querySelectorAll('input:not([disabled]), button:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')].filter((x) => x.getClientRects().length);
			if (!items.length) { e.preventDefault(); return; }
			const first = items[0], last = items[items.length - 1];
			if (!dialog.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
			else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
			else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
		};
		const dialog = h("div", { class: "rv-lx-dialog", role: "dialog", "aria-modal": "true", "aria-label": label }, build(close));
		wrap.append(dialog);
		wrap.addEventListener("mousedown", (e) => { if (e.target === wrap) close(undefined); });
		document.addEventListener("keydown", onKey, true);
		document.body.append(wrap);
		const first = dialog.querySelector("input, button, select, a[href]");
		if (first) first.focus();
	});
}

export async function confirmDialog(title, text, okLabel = "OK", danger = false) {
	return (await modal((close) => [
		h("h2", { text: title }),
		h("p", { text }),
		h("div", { class: "rv-lx-buttons" }, btn(okLabel, () => close(true), danger ? "rv-btn-danger" : "rv-btn-primary"), btn("Cancel", () => close(false))),
	], { label: title })) === true;
}

export async function copyText(text) {
	try { await navigator.clipboard.writeText(text); return true; } catch (e) { return false; }
}
